import type { ReactNode } from "react";
import { cx } from "../cx";

/** The right column of stacked Cards: 300px on most screens, 380px (Casting) or 420px (Audiobook) when `width` says so. */
export function Aside({
  children,
  width = "rail",
  className = "",
}: {
  children: ReactNode;
  width?: "rail" | "aside" | "wide";
  className?: string;
}) {
  const WIDTH = { rail: "w-rail", aside: "w-aside", wide: "w-aside-wide" } as const;
  return (
    <div
      data-component="Aside"
      className={cx("flex shrink-0 flex-col gap-4", WIDTH[width], className)}
    >
      {children}
    </div>
  );
}
